import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { KendoAllModule } from './kendo-all.module';
import { PafAllComponentsModule } from './paf-all-components.module';
import { PafAllDirectivesModule } from './paf-all-directives.module';
import { PafAllPipesModule } from './paf-all-pipes.module';
import { PafAllValidatorsModule } from './paf-all-validators.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KendoAllModule,
    PafAllComponentsModule,
    PafAllDirectivesModule,
    PafAllPipesModule,
    PafAllValidatorsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KendoAllModule,
    PafAllComponentsModule,
    PafAllDirectivesModule,
    PafAllPipesModule,
    PafAllValidatorsModule
  ]
})
export class PafCommonModule {}
